import authorization from "@/authorization";
import RolesView from "@/systems/modules/roles/RolesView.vue";

export default {
  getRoutes: () => [
      {
          name: "community.modules.roles",
          path: "roles",
          component: RolesView,
          props: true,
          meta: {
              authorize: () => authorization.permission("roles.edit")
          }
      }
  ]
};